module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-1-Whats-Your-Function-ES-10510c8fd0c65a94f6ad0c6bc1e7c34a.pdf";